import React from 'react';

const PrivacyPolicy = (props) => 
    { 
    
    

    if (props.lang === "EN") {
        return (
            <div>  
            <p>This Privacy Policy explains how Nadya Taylor of Nadya Taylor Consulting (“Provider”) collects, uses, stores, and protects personal data when you access the website or use online psychological services.</p>

            <h2>1. Data Controller</h2>
            <p>
            <strong>Nadya Taylor</strong><br/>

            Email: info@nadyataylor.ch<br />
            Website: https://www.nadyataylor.ch
            </p>

            <h2>2. Categories of Personal Data Collected</h2>
            <p>The Provider may collect and process the following categories of personal data:</p>
            <p>
            • Identification data (name, date of birth)<br />
            • Contact details (email address, telephone number)<br />
            • Billing and payment information<br />
            • Technical data (IP address, browser type, device information)<br />
            • Information shared during consultations or via intake forms<br />
            • Communication records</p>

            <h2>3. Purpose of Processing</h2>
            <p>Personal data is processed for the following purposes:</p>
            <p>• Provision of psychological or related services<br />
            • Appointment scheduling and administration<br />
            • Billing and payment processing<br />
            • Compliance with legal and professional obligations<br />
            • Website functionality and security<br />
            • Communication with clients</p>

            <h2>4. Legal Basis for Processing</h2>
            <p>Processing is based on one or more of the following legal grounds:</p>
            <p>• Performance of a contract<br />
            • Consent<br />
            • Compliance with legal obligations<br />
            • Legitimate professional interests, where applicable</p>

            <h2>5. Sensitive Data</h2>
            <p>Psychological services may involve the processing of sensitive personal data, including health-related information. Such data is processed confidentially and in accordance with applicable data protection and professional confidentiality obligations.</p>

            <h2>6. Data Sharing</h2>
            <p>Personal data may be shared only where necessary with:</p>
            <p>• Payment processors<br />
            • IT and hosting service providers<br />
            • Professional advisors or supervisors (where appropriate and anonymized where possible)<br />
            • Authorities where required by law</p>
            <p>The Provider does not sell personal data.</p>

            <h2>7. International Data Transfers</h2>
            <p>If personal data is transferred across borders, appropriate safeguards will be implemented in accordance with applicable data protection laws.</p>

            <h2>8. Data Retention</h2>
            <p>Personal data is retained only as long as necessary for the purposes described above, including compliance with legal, regulatory, and professional record-keeping obligations.</p>

            <h2>9. Data Security</h2>
            <p>The Provider implements reasonable technical and organizational measures to protect personal data against unauthorized access, loss, misuse, or disclosure.</p>
            <p>However, no method of electronic transmission or storage is entirely secure.</p>

            <h2>10. Client Rights</h2>
            <p>Depending on applicable law, you may have the right to:</p>
            <p>• Access your personal data<br />
            • Request correction of inaccurate data<br />
            • Request deletion where legally permissible<br />
            • Restrict or object to processing<br />
            • Withdraw consent (where processing is based on consent)<br />
            • Request data portability, where applicable</p>
            <p>Requests may be submitted using the contact details above.</p>

            <h2>11. Cookies and Website Analytics</h2>
            <p>The website may use cookies or similar technologies to improve functionality and user experience. You may control cookie preferences through your browser settings.</p>

            <h2>12. Third-Party Platforms</h2>
            <p>Online sessions may be conducted via third-party platforms. Use of such platforms is subject to their respective privacy policies and terms.</p>

            <h2>13. Children’s Data</h2>
            <p>Services are not directed toward individuals under 18 years of age without parental or legal guardian consent. The Provider does not knowingly collect data from minors without appropriate authorization.</p>

            <h2>14. Changes to this Policy</h2>
            <p>The Provider may update this Privacy Policy periodically. The version in effect at the time of data collection applies.</p>

            <h2>15. Contact</h2>
            <p>If you have questions regarding this Privacy Policy or the processing of your personal data, please contact:</p>
            <p>
            <strong>Nadya Taylor</strong><br />
            Email: info@nadyataylor.ch
            </p>
           </div>
        );
    } 
    if (props.lang === "RU") {
        return (
            <div>
                <p>Настоящая Политика конфиденциальности объясняет, как "Nadya Taylor от Nadya Taylor Consulting" ("Поставщик") собирает, использует, хранит и защищает персональные данные при использовании сайта или онлайн‑психологических услуг.</p>

                <h2>1. Контролёр данных</h2>
                <p>
                    <strong>Надя Тейлор</strong><br />

                    Email: info@nadyataylor.ch<br />
                    Сайт: https://www.nadyataylor.ch
                </p>

                <h2>2. Категории собираемых персональных данных</h2>
                <p>Поставщик может собирать и обрабатывать следующие категории персональных данных:</p>
                <p>
                • Идентификационные данные (имя, дата рождения)<br />
                • Контактные данные (адрес электронной почты, номер телефона)<br />
                • Платёжные и биллинговые данные<br />
                • Технические данные (IP‑адрес, тип браузера, информация об устройстве)<br />
                • Информация, предоставленная в ходе консультаций или через формы регистрации<br />
                • Записи коммуникаций</p>

                <h2>3. Цели обработки</h2>
                <p>Персональные данные обрабатываются для следующих целей:</p>
                <p>• Предоставление психологических и сопутствующих услуг<br />
                • Запись и администрирование приёма<br />
                • Обработка платежей и биллинга<br />
                • Соблюдение правовых и профессиональных обязательств<br />
                • Функционирование сайта и обеспечение безопасности<br />
                • Общение с клиентами</p>

                <h2>4. Правовые основания обработки</h2>
                <p>Обработка основана на одном или нескольких из следующих правовых основаниях:</p>
                <p>• Выполнение договора<br />
                • Согласие<br />
                • Соблюдение юридических обязательств<br />
                • Законные профессиональные интересы, если применимо</p>

                <h2>5. Особые категории данных</h2>
                <p>Психологические услуги могут включать обработку специальных категорий персональных данных, включая сведения о здоровье. Такие данные обрабатываются конфиденциально и в соответствии с применимым законодательством о защите данных и профессиональной тайной.</p>

                <h2>6. Передача данных третьим лицам</h2>
                <p>Персональные данные могут передаваться при необходимости:</p>
                <p>• Платёжным процессорам<br />
                • IT‑и хостинг‑провайдерам<br />
                • Профессиональным советникам или супервизорам (по мере необходимости и, где возможно, с анонимизацией)<br />
                • Органы власти по требованию закона</p>
                <p>Поставщик не продаёт персональные данные.</p>

                <h2>7. Международные передачи данных</h2>
                <p>Если персональные данные передаются через границы, будут приняты соответствующие меры защиты в соответствии с применимыми законами о защите данных.</p>

                <h2>8. Сроки хранения данных</h2>
                <p>Персональные данные хранятся только в течение срока, необходимого для целей, указанных выше, включая соблюдение юридических, регуляторных и профессиональных требований по учёту.</p>

                <h2>9. Безопасность данных</h2>
                <p>Поставщик реализует разумные технические и организационные меры для защиты персональных данных от несанкционированного доступа, утраты, неправильного использования или раскрытия.</p>
                <p>Тем не менее ни один способ передачи или хранения данных в электронном виде не может быть гарантирован как полностью безопасный.</p>

                <h2>10. Права субъектов данных</h2>
                <p>В зависимости от применимого законодательства вы можете иметь следующие права:</p>
                <p>• Доступ к вашим персональным данным<br />
                • Запрос исправления неточных данных<br />
                • Запрос удаления, если это разрешено законом<br />
                • Ограничение или возражение против обработки<br />
                • Отзыв согласия (если обработка основана на согласии)<br />
                • Запрос на переносимость данных, если применимо</p>
                <p>Запросы можно направлять по контактным данным, указанным выше.</p>

                <h2>11. Cookies и аналитика сайта</h2>
                <p>Сайт может использовать cookies или аналогичные технологии для улучшения функциональности и удобства. Управлять настройками cookies можно через настройки браузера.</p>

                <h2>12. Сторонние платформы</h2>
                <p>Онлайн‑сессии могут проводиться через сторонние платформы. Использование таких платформ регулируется их политиками конфиденциальности и условиями.</p>

                <h2>13. Данные детей</h2>
                <p>Услуги не направлены на лиц младше 18 лет без согласия родителя или законного представителя. Поставщик не собирает сознательно данные несовершеннолетних без соответствующего разрешения.</p>

                <h2>14. Изменения в Политике</h2>
                <p>Поставщик может периодически обновлять настоящую Политику конфиденциальности. Применяется версия, действующая на момент сбора данных.</p>

                <h2>15. Контакты</h2>
                <p>Если у вас есть вопросы относительно этой Политики конфиденциальности или обработки ваших персональных данных, пожалуйста, свяжитесь:</p>
                <p>
                    <strong>Надя Тейлор</strong><br />
                    Email: info@nadyataylor.ch
                </p>
            </div>
        );
    }
}
export default PrivacyPolicy;
